module.exports = __webpack_public_path__ + "static/media/jaguar.6f95d18f.png";